<template>
    <div id="app">
        <v-layout>
            <transition mode="out-in"
                v-on:enter="getAnimateIn"
                v-on:leave="getAnimateOut"
                v-bind:css="false"
                appear>

                <router-view :key="$route.path" ref="currentView" :parentRef="$refs"></router-view>

            </transition>
        </v-layout>
    </div>
</template>

<style lang="scss">
    @import './static/scss/app.scss';
</style>

<script>
    import { TimelineMax } from '@/vendor';
    import Simple from '@/app/layouts/Simple';

    export default {
        name: 'app',

        components: {
            'v-layout': Simple
        },

        mounted()
        {
            this.$fb.init();

            if( this.$route.query.debug )
            {
                this.$store.dispatch( 'setDebug', this.$route.query.debug );
            }

            if( this.$helpers.browserCheck().isIE )
            {
                document.documentElement.classList.add( 'is-ie' );
            }
        },

        methods: {
            getAnimateIn( el, done )
            {
                let tl = new TimelineMax({ onComplete: done });
                if( typeof this.$refs.currentView.getAnimateIn === 'function' )
                {
                    tl.add( this.$refs.currentView.getAnimateIn(), 0 );
                }
            },

            getAnimateOut( el, done )
            {
                let tl = new TimelineMax({ onComplete: done });
                if( typeof this.$refs.currentView.getAnimateOut === 'function' )
                {
                    tl.add( this.$refs.currentView.getAnimateOut(), 0 );
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/App.vue